<template>
  <dialog id="rename_modal" class="modal">
    <div class="modal-box">
      <h3 class="mb-2 text-lg font-bold">Đổi tên tệp tin</h3>
      <div class="flex items-baseline gap-2">
        <span>{{ parent_dir }}</span>
        <input class="input" v-model="new_name" />
      </div>
      <div class="modal-action">
        <form method="dialog" class="flex gap-2">
          <button class="btn btn-outline">Hủy bỏ</button>
          <button class="btn btn-primary" @click="handle_rename(new_name)">
            Xác nhận
          </button>
        </form>
      </div>
    </div>
  </dialog>
</template>
<script setup lang="ts">
import { ref, watch } from "vue";
import { use_explorer } from "./useExplorer";

const explorer_store = use_explorer();
const props = defineProps<{
  parent_dir?: string;
  file_name?: string;
}>();
const new_name = ref(props.file_name);
watch(
  () => props.file_name,
  () => {
    new_name.value = props.file_name;
  },
);
const handle_rename = (new_name: string | undefined) => {
  if (!props.parent_dir || !props.file_name || !new_name) return;

  explorer_store.handle_rename(
    `${props.parent_dir}\\${props.file_name}`,
    `${props.parent_dir}\\${new_name}`,
  );
};
</script>
